import { Header } from '@components/Header';
import DownloadAppIcon from '@components/icons/DownloadApp.svg';
import { getDownloadDesktopAppLink } from '@helpers/getDownloadDesktopAppLink';
import { useAPI } from '@providers/useAPI';
import { useMutation } from '@tanstack/react-query';
import { UserService } from 'app/API';
import { Helmet } from 'react-helmet-async';

import { Content } from './styles/Content';
import { Description } from './styles/Description';
import { Flex } from './styles/Flex';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { Title } from './styles/Title';

export const DesktopAppHelpPage = () => {
  const { call } = useAPI();
  const downloadedClientMutation = useMutation({
    mutationFn: () => call(() => UserService.downloadedClient()),
  });

  const onClick = () => {
    const link = getDownloadDesktopAppLink();
    downloadedClientMutation.mutate();
    window?.open(link, '_blank');
  };

  return (
    <>
      <Helmet>
        <title>Desktop App Help - AutoScript</title>
      </Helmet>
      <Header title="Desktop App Help" />

      <Content>
        <Flex>
          <OutlinedButton key="button" className="w-[170px] gap-[5px] justify-center" onClick={onClick}>
            <DownloadAppIcon />
            Download AutoScript
          </OutlinedButton>
          <Description>Enhanced editing features and audio player</Description>
        </Flex>

        <Title>AutoScript Desktop User Guide</Title>
        <video controls width="100%" poster="https://autoscript-assets.s3.us-east-1.amazonaws.com/video/Desktop.jpg">
          <source src="https://autoscript-assets.s3.us-east-1.amazonaws.com/video/Desktop.mp4" type="video/mp4" />
          <p>
            Your browser {"doesn't"} support HTML video. Here is a{' '}
            <a href="https://autoscript-assets.s3.us-east-1.amazonaws.com/video/Desktop.mp4">link to the video</a>{' '}
            instead.
          </p>
        </video>
      </Content>
    </>
  );
};
